export const ERROR_DEFAULT_HEIGHT = 300;

// System error messages
export const ERROR_MESSAGE_DEFAULT = 'Temporarily unavailable';
export const ERROR_MESSAGE_DEFAULT_BODY =
  "We're looking into it and expect our usual service to return soon.";
export const ERROR_MESSAGE_UNAUTHORIZED = 'Your session has expired';

// Known/handled errors (displayed to users with custom styling). These can be
// thrown explicitly (e.g. throw new Error(...)) with the messages used directly,
// or, they can be passed as the "message" property to the ErrorBoundary component.
//
// "_FAILED" suffixes imply the resource failed to load, more of a bigger service
// outage/service not deployed in a specific environment.
//
// "_NOT_FOUND" suffixes imply an expected value isn't present or was doesn't
// exist, not necessarily due to a service outage.
export const ERROR_MESSAGE_ACCESS_CHECK_FAILED = 'Access check is temporarily unavailable';
export const ERROR_MESSAGE_ASSET_DEFAULT_NETWORK_NOT_FOUND =
  'No default network found for the selected asset';

// Portfolio Page
export const ERROR_MESSAGE_PORTFOLIO_SUMMARY_FAILED =
  'Portfolio summary is temporarily unavailable';
export const ERROR_MESSAGE_PORTFOLIO_POSITIONS_FAILED =
  'Portfolio positions are temporarily unavailable';

// Pools Page
export const ERROR_MESSAGE_POOLS_SUMMARY_FAILED = 'Pools summary is temporarily unavailable';
export const ERROR_MESSAGE_POOLS_LIST_FAILED = 'Pools list is temporarily unavailable';

// Portfolio > Position Page
export const ERROR_MESSAGE_POSITION_INFO_FAILED = 'Position info is temporarily unavailable';
export const ERROR_MESSAGE_POSITION_TOKEN_DETAILS_FAILED =
  'Position token details are temporarily unavailable';
export const ERROR_MESSAGE_POSITION_RANGE_DETAILS_FAILED =
  'Position range details are temporarily unavailable';

// Add Liquidity Page
export const ERROR_MESSAGE_ADD_LIQUIDITY_FAILED = 'Adding liquidity is temporarily unavailable';

// Remove Liquidity Page
export const ERROR_MESSAGE_REMOVE_LIQUIDITY_FAILED =
  'Removing liquidity is temporarily unavailable';

// Faucet Page
export const ERROR_MESSAGE_FAUCET_FAILED = 'Faucet is temporarily unavailable';

// Swap Page
export const ERROR_MESSAGE_SWAP_FAILED = 'Swap is temporarily unavailable';

// Errors explicitly thrown (e.g. throw new Error(...)) with the messages below
// are to be treated as known/handled. They will be displayed with custom styling
// in their respective error boundaries. Throwing an error with a message not listed
// will result in the default error message being displayed.
export const ERRORS = [
  ERROR_MESSAGE_ACCESS_CHECK_FAILED,
  ERROR_MESSAGE_ASSET_DEFAULT_NETWORK_NOT_FOUND,
  ERROR_MESSAGE_PORTFOLIO_SUMMARY_FAILED,
  ERROR_MESSAGE_PORTFOLIO_POSITIONS_FAILED,
  ERROR_MESSAGE_POOLS_SUMMARY_FAILED,
  ERROR_MESSAGE_SWAP_FAILED,
];
